import { Button, Label, TextInput, Datepicker } from "flowbite-react";
import { HiTrash } from "react-icons/hi";
import { useTranslation } from "react-i18next";

// Convert MM-DD string to Date object (uses current year)
const mmddToDate = (mmdd) => {
  if (!mmdd || !/^\d{2}-\d{2}$/.test(mmdd)) return null;
  const [month, day] = mmdd.split("-").map(Number);
  const date = new Date();
  date.setMonth(month - 1);
  date.setDate(day);
  return date;
};

// Convert Date object to MM-DD string
const dateToMmdd = (date) => {
  if (!date) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}-${day}`;
};

export const DateRangeRow = ({
  dateRange,
  index,
  onUpdate,
  onRemove,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleChange = (field, value) => {
    onUpdate(index, { ...dateRange, [field]: value });
  };

  const handleDateChange = (field, date) => {
    const mmdd = dateToMmdd(date);
    onUpdate(index, { ...dateRange, [field]: mmdd });
  };

  return (
    <div className="flex items-end gap-3">
      <div className="flex-1">
        <div className="mb-1">
          <Label
            htmlFor={`name-${index}`}
            value={t("pages.settings.actionsSettings.seasonality.name")}
          />
        </div>
        <TextInput
          id={`name-${index}`}
          type="text"
          value={dateRange.name || ""}
          onChange={(e) => handleChange("name", e.target.value)}
          placeholder={t(
            "pages.settings.actionsSettings.seasonality.namePlaceholder",
          )}
          disabled={disabled}
        />
      </div>
      <div className="w-40">
        <div className="mb-1">
          <Label
            htmlFor={`start-${index}`}
            value={t("pages.settings.actionsSettings.seasonality.startDate")}
          />
        </div>
        <Datepicker
          id={`start-${index}`}
          value={mmddToDate(dateRange.start)}
          onSelectedDateChanged={(date) => handleDateChange("start", date)}
          disabled={disabled}
          showClearButton={false}
          showTodayButton={false}
        />
      </div>
      <div className="w-40">
        <div className="mb-1">
          <Label
            htmlFor={`end-${index}`}
            value={t("pages.settings.actionsSettings.seasonality.endDate")}
          />
        </div>
        <Datepicker
          id={`end-${index}`}
          value={mmddToDate(dateRange.end)}
          onSelectedDateChanged={(date) => handleDateChange("end", date)}
          disabled={disabled}
          showClearButton={false}
          showTodayButton={false}
        />
      </div>
      <Button
        color="failure"
        size="sm"
        onClick={() => onRemove(index)}
        disabled={disabled}
        className="mb-0.5"
      >
        <HiTrash className="h-4 w-4" />
      </Button>
    </div>
  );
};
